// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './error-handler.css';

var ErrorHandler = CreateReactClass({
    propTypes : {

    },
    defaultProps : {

    },
    componentDidMount() {
        var updatePossition= setTimeout(function(){
            this.setState({
                top: this.props.position,
            });
        }.bind(this), 100)
    },
    getInitialState: function () {
        return {
            top: 0,
        };
    },
    render: function () {
        return (

            <div className="errorHandler" style={{top : this.state.top}}>
                {this.props.message}
            </div>
        )
    }
});

module.exports = ErrorHandler;





// WEBPACK FOOTER //
// ./src/components/common/error-handler.js